import api from "@/lib/axios";

export const formService = {
  async getForm(id) {
    const response = await api.get(`/v1/forms/${id}`);
    return response.data;
  },

  async getAllForms() {
    const response = await api.get('/v1/forms');
    return response.data;
  },

  async createForm(data) {
    const response = await api.post('/v1/forms', data);
    return response.data;
  },

  async updateForm(id, data) {
    const response = await api.put(`/v1/forms/${id}`, data);
    return response.data;
  },

  async deleteForm(id) {
    const response = await api.delete(`/v1/forms/${id}`);
    return response.data;
  },

  async submitForm(id, data) {
    const response = await api.post(`/v1/forms/${id}/submit`, data);
    return response.data;
  },

  async getInitialFormSubmission(formId) {
    const response = await api.post(`/v1/initial-form-submission/${formId}`);
    return response.data;
  }
}; 